import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { AssetFinanceUrl } from "../../../../config";
import Form from "./form";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import Joyride from "react-joyride"; // Import Joyride
import { executeAnyMutation } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const base_url = AssetFinanceUrl.uri;

// Define tour steps for the page
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Collateral Asset Sub-Type setup page, where you can manage Asset Sub-Types.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find specific Asset Sub-Types by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Asset Sub-Type.",
    placement: "right",
  },
  {
    target: ".dynamic-table-actions",
    content: "Select actions to be able to Edit each Asset Sub-Type from this dropdown.",
    placement: "left",
  },
];

const CollateralAssetSubtypesTable = () => {
  const [runTour, setRunTour] = useState(false); // State to control Joyride

  const handleToggle = async (row, field, currentValue, label, refetch) => {
    const isDeactivating = !!currentValue;
    const action = isDeactivating ? "Deactivate" : "Activate";
    const confirm = await Swal.fire({
      title: `${action} ${label}?`,
      text: `Are you sure you want to ${action.toLowerCase()} "${row.AssetSubTypeName}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });
    if (!confirm.isConfirmed) return;

    const response = await executeAnyMutation(
      "updateAssetSubType",
      {
        id: row.Id,
        assetTypeId: row.AssetTypeId,
        code: row.AssetSubTypeCode,
        displayName: row.AssetSubTypeName,
        companyId: row.CompanyId,
        [field]: !currentValue,
      },
      "assetSubType",
      false,
      base_url
    );

    if (response?.results) {
      await Swal.fire("Done!", `${label} has been updated.`, "success");
      if (refetch) refetch();
    } else {
      await Swal.fire("Error!", "Could not update the Asset Sub-Type. Please try again.", "error");
    }
  };

  const actions = {
    entity: localStorage.getItem("SelectedTabLabel"),
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    toggleActive: {
      key: "TOGGLE_ACTIVE",
      button_name: (row) => (row?.IsActive ? "Deactivate" : "Activate"),
      Show_Button: true,
      permission: "EditPermission",
      onClick: (row, refetch) => handleToggle(row, "isActive", row?.IsActive, "Active Status", refetch),
    },
    toggleSpousalConsent: {
      key: "TOGGLE_SPOUSAL_CONSENT",
      button_name: (row) => (row?.RequiresSpousalConsent ? "Remove Spousal Consent" : "Require Spousal Consent"),
      Show_Button: true,
      permission: "EditPermission",
      onClick: (row, refetch) => handleToggle(row, "requiresSpousalConsent", row?.RequiresSpousalConsent, "Spousal Consent Requirement", refetch),
    },
    dataObject: {
      ignoreFields: [
        "CreatedAt",
        "CreatedBy",
        "UpdatedAt",
        "UpdatedBy",
        "AdditionalMetadataSchema",
        "CompanyId",
        "AssetTypeId",
        "IndicativeDepreciationPct",
        "ValidityMonthsOverride",
        "RequiresCommercialLicence",
        "RequiresLcbConsent"
      ],
      objectName: "allAssetSubTypes",
      parameters: "",
    },
    isSubRight: true,
    showStatus: true,
    showMore: {
      search: false,
      min: 0,
      max: 0,
    },
  };

  return (
    <Box m="20px">
      {/* Joyride Component */}
      <Joyride
        steps={rightsTourSteps}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        styles={{
          options: {
            primaryColor: "#1976d2",
            zIndex: 10000,
          },
        }}
      />
      {/* Top Bar */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
          Start Page Tour
        </Button>
      </Box>
      <DynamicTableForJson
        title="Collateral Asset Sub-Type Management"
        subtitle="Manage Asset Sub-Types"
        FormComponent={Form}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps}
      />
    </Box>
  );
};

export default CollateralAssetSubtypesTable;
